.w{width:100%;}